<template>
  <div class="chart-container">
    <Line
      :data="chartData"
      :options="chartOptions"
      class="chart"
    />
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default {
  name: 'UserGrowthChart',
  components: { Line },
  props: {
    stats: {
      type: Object,
      required: true
    }
  },
  computed: {
    chartData() {
      if (!this.stats?.user_per_month?.[0]?.monthlyData || !this.stats?.mau?.[0]?.monthlyData) {
        return {
          labels: [],
          datasets: []
        };
      }

      const monthlyData = this.stats.user_per_month[0].monthlyData;
      const mauData = this.stats.mau[0].monthlyData;

      // Calculer le cumul des utilisateurs
      let cumulativeUsers = 0;
      const cumulativeData = monthlyData.map(item => {
        cumulativeUsers += item.newUsers;
        return cumulativeUsers;
      });

      // Formater les labels des mois
      const labels = monthlyData.map(item => {
        const date = new Date(item.month.year, item.month.month - 1);
        return date.toLocaleString('fr-FR', { month: 'long' });
      });

      return {
        labels,
        datasets: [
          {
            label: 'Utilisateurs actifs MAU',
            data: mauData.map(item => item.activeUsers),
            borderColor: '#FFA726',
            backgroundColor: '#FFB74D',
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 6
          },
          {
            label: 'Nouveaux utilsateurs mensuels',
            data: monthlyData.map(item => item.newUsers),
            borderColor: '#4DB6AC',
            backgroundColor: '#80CBC4',
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 6
          },
          {
            label: "Nombre d'Utilisateurs",
            data: cumulativeData,
            borderColor: '#2E7D32',
            backgroundColor: '#388E3C',
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 6
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
            labels: {
              font: {
                family: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                size: 12
              },
              padding: 20,
              usePointStyle: true,
              pointStyle: 'circle'
            }
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            titleColor: '#333',
            bodyColor: '#666',
            borderColor: '#ddd',
            borderWidth: 1,
            padding: 12,
            bodyFont: {
              size: 13
            },
            titleFont: {
              size: 14,
              weight: 'bold'
            },
            callbacks: {
              label: function(context) {
                return `${context.dataset.label}: ${context.parsed.y.toLocaleString('fr-FR')}`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(0, 0, 0, 0.1)',
              drawBorder: false
            },
            ticks: {
              font: {
                size: 12
              },
              callback: function(value) {
                return value.toLocaleString('fr-FR');
              }
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 12
              }
            }
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  background: white;
  border-radius: 16px;
  padding: 20px;
  height: 400px;
  margin: 20px 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.chart {
  width: 100%;
  height: 100%;
}
</style> 